// extracted by mini-css-extract-plugin
module.exports = {"paginated-button":"styles-module__paginated-button___2_NVA"};